import React, { useState } from "react";
import { ChromePicker } from "react-color";

import styles from "./styles.module.scss";

const ColorPicker = props => {
  const { onChange, placeholder, value } = props;

  const [showColorPicker, setShowColorPicker] = useState(false);

  const handleClick = () => {
    setShowColorPicker(!showColorPicker);
  };

  const handleClose = () => {
    setShowColorPicker(false);
  };

  const handleChangeColor = event => {
    const hexColor = event ? event.hex : event;
    onChange && onChange(hexColor);
  };

  return (
    <React.Fragment>
      <div
        onClick={handleClick}
        className={styles.input}
        style={{ background: value }}
      >
        {!value && placeholder}
      </div>
      {showColorPicker && (
        <div className={styles.popover}>
          <div className={styles.cover} onClick={handleClose}></div>
          <ChromePicker color={value || ""} onChange={handleChangeColor} />
        </div>
      )}
    </React.Fragment>
  );
};

export default ColorPicker;
